<template>
  <div class="iprdb_login_wrapper">
    <div id="login_container" v-loading="loading">
      <div class="brand">
        <img
       
     
          src="../assets/images/logo/logo2.png"
        />
      </div>
      <div class="form_box">
        <div class="earth_box">
          <div class="earth_title">ISE乘用车数据分析平台</div>
          <img class="earth_img" src="../assets/images/index/earth.png" />
        </div>
        <div class="login_box" >
          <div class="login_title">登   录</div>
          <div class="login_input_wrapper" style="margin-top:60px">
             <span class="sl">用户名：</span>
       <el-input
              v-model="userNameOrEmailAddress"

              height="36"
            />
       
          </div>
          <div class="login_input_wrapper">
             <span class="sl">密   &nbsp; 码：</span>
            <el-input v-model="password" show-password  />
          </div>
          <div class="login_btn">
            <div class="login_btn_title" @click="doLogin">登录</div>
            <div class="login_btn_shadow" style="display:none"></div>
          </div>
          <div class="login_tip_box">
            <!-- 注册 -->
            <div class="tip_txt"></div>
            <div class="tip_txt" style="" @click="doTest">测试帐号</div>
          </div>
          <div class="third_service_box" style="">
           
          </div>
          <div class="wechat_and_qq_box" style="display: none">
            <img src="@/assets/images/index/weixin.png" />
            <img src="@/assets/images/index/qq.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      rememberClient: false,
      userNameOrEmailAddress: "",
      password: "",

      loading: false,
      tenant: {
        name: "isengine",
      },
    };
  },
  methods: {
    ...mapMutations(["setLoggedIn"]),
    ...mapActions("user", ["login", "getUserConfig", "getCurrentLoginInfo"]),
    doLogin() {
      this.loading = true;
      var postData = {
        rememberClient: false,
        userNameOrEmailAddress: this.userNameOrEmailAddress,
        password: this.password,
      };
      this.login({
        params: postData,
        handle: this.lh,
      });
    },
    doTest() {
      this.loading = true;
      this.login({
        params: {
          rememberClient: false,
          userNameOrEmailAddress: "guest",
          password: "guest",
        },
        handle: this.lh,
      });
    },
    lh(res) {
      var self = this;
      console.log(res);
      this.loading = false;
      //  alert(res.data.result.accessToken);
      //  alert(res.data.result.userId);
      // alert(res.data.result.encryptedAccessToken);
      if (res && res.data && res.data.success) {
        localStorage.setItem("ss", res.data.result.accessToken);
        localStorage.setItem("userId", res.data.result.userId);
        localStorage.setItem(
          "encryptedAccessToken",
          res.data.result.encryptedAccessToken
        );
        self.setLoggedIn(true);

       // this.getCurrentLoginInfo({ handle: null });
        this.getUserConfig({ handle: function () {
 
          self.$router.push({ name: "index" });
        } });
        //   alert(localStorage.getItem('ss'));
      } else {
        self.$message({
          message: "用户名或密码错误 ",
          duration: 2000,
        });
      }
    },
  },

  computed: {
    ...mapGetters("user", [
      "currentLoginInfo",
      "userConfig",
      "token",
      "checkPermission",
    ]),
  },

  created() {
  
  },
  watch: {
    userConfig(newValue) {
      this.$router.push({ name: "index" });
    },
  },
};
</script>